import { Reveal, Eyebrow } from "@/components/Reveal";
import { CheckCircle2 } from "lucide-react";
import { imgSrc } from "@/lib/api";

const PROMISES = [
  "Milestone-based delivery — you approve each stage before we move on",
  "A written revision policy agreed before any work begins",
  "Full ownership of your website, content and domain on completion",
  "Plain-language proposals — no jargon, no hidden costs",
];

export default function About({ site }) {
  return (
    <section id="about" className="py-24 lg:py-32" data-testid="about-section">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-6 lg:grid-cols-2">
        <Reveal>
          <div className="relative">
            <div className="overflow-hidden rounded-3xl border border-white/10">
              <img
                src={imgSrc(site.about_image)}
                alt="Abstract chrome forms representing engineering and precision"
                className="max-h-[80vh] w-full object-cover transition-transform duration-700 hover:scale-105"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 rounded-2xl border border-white/10 bg-[#0A0F1C] px-6 py-5 shadow-2xl sm:-right-6">
              <p className="font-display text-sm font-bold uppercase tracking-[0.2em] text-[#00F0FF]">
                Ideas Engineered
              </p>
              <p className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white">
                Digitally.
              </p>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <Eyebrow>About Tarbyte</Eyebrow>
            <h2 className="font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
              {site.about_heading}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            {site.about_paragraphs.map((p, i) => (
              <p key={i} className={`${i === 0 ? "mt-7" : "mt-5"} text-base leading-relaxed text-slate-400 sm:text-lg`}>
                {p}
              </p>
            ))}
          </Reveal>
          <Reveal delay={0.2}>
            <ul className="mt-9 space-y-4">
              {PROMISES.map((p) => (
                <li key={p} className="flex items-start gap-3 text-sm text-slate-300">
                  <CheckCircle2 size={18} className="mt-0.5 shrink-0 text-[#00F0FF]" />
                  {p}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
